import { z } from 'zod';

export const step1Schema = z.object({
  full_name: z
    .string()
    .min(1, 'שדה חובה')
    .min(2, 'השם קצר מדי')
    .max(80, 'השם ארוך מדי'),
});
export type Step1Input = z.infer<typeof step1Schema>;

const optionalNineDigits = z
  .string()
  .optional()
  .refine((v) => !v || /^\d{9}$/.test(v), '9 ספרות בלבד');

export const step2Schema = z.object({
  org_name: z
    .string()
    .min(1, 'שדה חובה')
    .min(2, 'שם העסק קצר מדי')
    .max(100, 'שם העסק ארוך מדי'),
  business_id: optionalNineDigits,
  vat_id: optionalNineDigits,
});
export type Step2Input = z.infer<typeof step2Schema>;

// Step 3 is read-only defaults in Phase 0; no validation needed.

export interface WizardData {
  full_name: string;
  org_name: string;
  business_id: string;
  vat_id: string;
}
